import { BaseCodeDto } from '../dto/base.dto';

export enum DOCUMENT_TYPE {
  //ALCS
  DECISION_DOCUMENT = 'DPAC',
  OTHER = 'OTHR',
  ORIGINAL_APPLICATION = 'ORIG',
  REFERRAL = 'REFR',

  //Government Review
  RESOLUTION_DOCUMENT = 'RESO',
  STAFF_REPORT = 'STFF',

  //Applicant Uploaded
  CORPORATE_SUMMARY = 'CORS',
  PROFESSIONAL_REPORT = 'PROR',
  PHOTOGRAPH = 'PHTO',
  AUTHORIZATION_LETTER = 'AAGR',
  CERTIFICATE_OF_TITLE = 'CERT',

  //App Documents
  SERVING_NOTICE = 'POSN',
  PROPOSAL_MAP = 'PRSK',
  HOMESITE_SEVERANCE = 'HOME',
  CROSS_SECTIONS = 'SPCS',
  RECLAMATION_PLAN = 'RECP',
  NOTICE_OF_WORK = 'NOWE',
  PROOF_OF_SIGNAGE = 'POSA',
  REPORT_OF_PUBLIC_HEARING = 'ROPH',
  PROOF_OF_ADVERTISING = 'POAA',

  // NOI Documents
  BUILDING_PLAN = 'BLDP',

  //SRW
  SRW_TERMS = 'SRTD',
  SURVEY_PLAN = 'SURV',

  // C&E
  COMPLAINT = 'CMPL',
  BC_ASSESSMENT_REPORT = 'BCAR',
  CORRESPONDENCE = 'CORP',
  C_AND_E_NOTICE = 'CAEL',
  C_AND_E_ORDER = 'CEOO',
  C_AND_E_INSPECTION = 'INSP',
  GOOGLE_EARTH_FILE = 'GEFI',

  // Maps
  ALC_CONTEXT_MAP = 'LMAP',
  AIRPHOTO_MAP = 'PMAP',
  AMENDMENT_MAP = 'AMAP',
  CAPABILITY_MAP = 'CMAP',
  TENURE_MAP = 'TMAP',
}

export enum DOCUMENT_SOURCE {
  // All types
  ALC = 'ALC',
  LFNG = 'L/FNG',
  PUBLIC = 'Public',
  BC_GOVERNMENT = 'BC Government',
  OTHER_AGENCY = 'Other Agency',

  // app, NOI, noti, inquiry, planning review only
  APPLICANT = 'Applicant',
  AFFECTED_PARTY = 'Affected Party',

  // C&E only
  AGENT = 'Agent',
  COMPLAINANT = 'Complainant',
  PROPERTY_OWNER = 'Property Owner',
  TENANT = 'Tenant',
}

export const DEFAULT_DOCUMENT_SOURCES = [
  DOCUMENT_SOURCE.ALC,
  DOCUMENT_SOURCE.LFNG,
  DOCUMENT_SOURCE.PUBLIC,
  DOCUMENT_SOURCE.BC_GOVERNMENT,
  DOCUMENT_SOURCE.OTHER_AGENCY,
  DOCUMENT_SOURCE.APPLICANT,
  DOCUMENT_SOURCE.AFFECTED_PARTY,
];

export const C_AND_E_DOCUMENT_SOURCES = [
  DOCUMENT_SOURCE.ALC,
  DOCUMENT_SOURCE.LFNG,
  DOCUMENT_SOURCE.PUBLIC,
  DOCUMENT_SOURCE.BC_GOVERNMENT,
  DOCUMENT_SOURCE.OTHER_AGENCY,
  DOCUMENT_SOURCE.APPLICANT,
  DOCUMENT_SOURCE.AFFECTED_PARTY,
];

export enum DOCUMENT_SYSTEM {
  ALCS = 'ALCS',
  PORTAL = 'Portal',
  OATS = 'OATS',
  OATS_P = 'OATS_P',
}

export interface DocumentTypeDto extends BaseCodeDto {
  code: DOCUMENT_TYPE;
  oatsCode: string;
}
